import React, { useRef, useEffect } from "react";
import { SearchBox } from "@quintype/components";
import { string, object } from "prop-types";

import Icon from "../../../icons";
import { staticTexts } from "../../../utils/Translate";

import "./navbarSearch.m.css";
const SearchFormButtonClick = () => {
  if (document.getElementById("searchForm").value === "") {
    window.location = "/search";
  }
};
const DrawForm = ({ children }) => [
  <label htmlFor="searchForm" key="1" styleName="search-label" className="search-label">
    {children}
  </label>,
  <button
    type="submit"
    styleName="search__form-submit"
    className="search__form-submit"
    key="2"
    data-tracking-category="Button"
    data-tracking-action="Click"
    data-tracking-label="সার্চ বাটন"
    onClick={SearchFormButtonClick}
  >
    <Icon
      type="search"
      className="search-icon"
      datatrackingcategory="Button"
      datatrackingaction="Click"
      datatrackinglabel="সার্চ বাটন"
    />
  </button>,
];

const NavbarSearch = ({ device = "desktop", publisherAttributes }) => {
  const textInput = useRef();
  const searchForm = useRef();

  useEffect(() => {
    const inputElements = document.getElementsByTagName("input");
    Array.from(inputElements).forEach((item) => item.blur());
  }, []);

  return (
    <div styleName={`search ${device}`} className="search">
      <SearchBox
        styleName="search-box"
        inputId="searchForm"
        inputClassName={`search__form-input ${publisherAttributes.lang}-search__form-input`}
        template={DrawForm}
        inputRef={textInput}
        formRef={searchForm}
        placeholder={staticTexts(publisherAttributes.lang).searchBoxText}
        className="search-box"
      />
    </div>
  );
};

NavbarSearch.propTypes = {
  device: string,
  publisherAttributes: object,
};

export default NavbarSearch;
